<!-- <p-toast></p-toast> -->
<div class="mb-2">
    <!-- <p-card styleClass="p-card-shadow"> -->
        <div class="card grid">
            <div class="col-12 md:col-3">
            </div>
            <div class="col-12 md:col-6">
                <div class="flex  justify-content-between flex-wrap">
                    <div class="flex flex-column align-items-center justify-content-center col-12 md:col-6">
                        <h6 >{{'SELECT_SUBSIDY_LOT'| translate}}</h6>
                        <p-dropdown (onChange)="onApplicationTypeSelected($event)" [options]="dropDownList" label="zz"
                            placeholder="{{'SELECT_APPLICATION_TYPE'| translate}}" optionLabel="type" [(ngModel)]="applicationSelected" 
                            [disabled]="">
                        </p-dropdown>
                    </div>
                    <div class="flex align-items-center justify-content-center col-12 md:col-6">
                       
                    </div>
                </div>
               
                
            </div>
        </div>

    <!-- </p-card> -->
</div>
<router-outlet ></router-outlet>



